import React, { useEffect, useRef } from 'react';
export function MatrixRain() {
  const canvasRef = useRef<HTMLCanvasElement>(null);
  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext('2d');
    if (!ctx) return;
    // Set canvas size
    const resizeCanvas = () => {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
    };
    resizeCanvas();
    window.addEventListener('resize', resizeCanvas);
    // Matrix characters - mix of katakana, numbers, and letters
    const katakana = 'アァカサタナハマヤャラワガザダバパイィキシチニヒミリヰギジヂビピウゥクスツヌフムユュルグズブヅプエェケセテネヘメレヱゲゼデベペオォコソトノホモヨョロヲゴゾドボポヴッン';
    const numbers = '0123456789';
    const letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    const chars = katakana + numbers + letters + '369';
    // Column settings - more columns for denser effect
    const fontSize = 16;
    const columns = Math.floor(canvas.width / fontSize);
    // Array to track y position of each column
    const drops: number[] = Array(columns).fill(1);
    // Random initial positions
    for (let i = 0; i < drops.length; i++) {
      drops[i] = Math.random() * -100;
    }
    // Colors matching the Matrix theme - brighter for more visibility
    const primaryColor = '#00ff41'; // Classic Matrix green
    const secondaryColor = '#00d9ff'; // Cyan
    const tertiaryColor = '#00ffcc'; // Teal
    const dimColor = '#0a6a4a'; // Brighter dim green
    let animationId: number;
    const draw = () => {
      // Semi-transparent black to create fade effect
      ctx.fillStyle = 'rgba(10, 15, 13, 0.08)';
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      ctx.font = `${fontSize}px monospace`;
      for (let i = 0; i < drops.length; i++) {
        // Random character
        const char = chars[Math.floor(Math.random() * chars.length)];
        // Calculate position
        const x = i * fontSize;
        const y = drops[i] * fontSize;
        // Vary the color and brightness - more bright characters
        const brightness = Math.random();
        if (brightness > 0.95) {
          // Bright head of the stream - white
          ctx.fillStyle = '#ffffff';
          ctx.shadowBlur = 15;
          ctx.shadowColor = primaryColor;
        } else if (brightness > 0.85) {
          // Bright green
          ctx.fillStyle = primaryColor;
          ctx.shadowBlur = 10;
          ctx.shadowColor = primaryColor;
        } else if (brightness > 0.7) {
          // Cyan accent
          ctx.fillStyle = secondaryColor;
          ctx.shadowBlur = 5;
          ctx.shadowColor = secondaryColor;
        } else if (brightness > 0.5) {
          // Teal accent
          ctx.fillStyle = tertiaryColor;
          ctx.shadowBlur = 0;
        } else {
          // Dimmer characters
          ctx.fillStyle = dimColor;
          ctx.shadowBlur = 0;
        }
        ctx.fillText(char, x, y);
        ctx.shadowBlur = 0;
        // Reset drop to top with random delay
        if (y > canvas.height && Math.random() > 0.975) {
          drops[i] = 0;
        }
        // Move drop down
        drops[i]++;
      }
      animationId = requestAnimationFrame(draw);
    };
    draw();
    return () => {
      window.removeEventListener('resize', resizeCanvas);
      cancelAnimationFrame(animationId);
    };
  }, []);
  return <canvas ref={canvasRef} className="fixed inset-0 pointer-events-none" style={{
    zIndex: 1,
    opacity: 0.5
  }} aria-hidden="true" data-id="element-120" />;
}